import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const LOGO_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_96799fa3-9756-486c-a9c0-3e62e84360a1/artifacts/lhrzswk5_Screenshot_20260819_053152_Gallery.jpg";

export function Logo({ light }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
      <img src={LOGO_URL} alt="J-Computer logo"
        className={`h-10 w-10 rounded-lg object-cover ring-1 transition-all group-hover:ring-blue-500 ${light ? "ring-slate-700" : "ring-slate-200"}`} />
      <span className={`text-xl font-black tracking-tighter font-display ${light ? "text-white" : "text-slate-900"}`}>
        J-Computer<span className="text-blue-500">.</span>
      </span>
    </Link>
  );
}

const links = [
  { to: "/#ydelser", label: "Ydelser" },
  { to: "/#om", label: "Om os" },
  { to: "/booking", label: "Book service" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const goDash = () => navigate(user?.role === "admin" ? "/admin" : "/portal");

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.to} href={l.to} data-testid={`nav-${l.label}`}
               className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Button variant="ghost" onClick={goDash} data-testid="nav-dashboard-btn"
                      className="text-slate-700 hover:text-blue-600">
                {user.role === "admin" ? "Admin" : "Min portal"}
              </Button>
              <Button onClick={logout} data-testid="nav-logout-btn" variant="outline"
                      className="rounded-full border-slate-300">Log ud</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn"
                      className="text-slate-700 hover:text-blue-600">Log ind</Button>
              <Button onClick={() => navigate("/booking")} data-testid="nav-book-btn"
                      className="rounded-full bg-blue-600 hover:bg-blue-700 shadow-[0_0_20px_rgba(37,99,235,0.35)]">
                Book service
              </Button>
            </>
          )}
        </div>
        <button className="md:hidden text-slate-800" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <a key={l.to} href={l.to} onClick={() => setOpen(false)}
               className="text-slate-700 font-medium py-1">{l.label}</a>
          ))}
          <div className="flex gap-2 pt-2">
            {user ? (
              <>
                <Button onClick={goDash} className="flex-1 bg-blue-600 hover:bg-blue-700">
                  {user.role === "admin" ? "Admin" : "Min portal"}
                </Button>
                <Button onClick={logout} variant="outline" className="flex-1">Log ud</Button>
              </>
            ) : (
              <>
                <Button onClick={() => navigate("/login")} variant="outline" className="flex-1">Log ind</Button>
                <Button onClick={() => navigate("/booking")} className="flex-1 bg-blue-600 hover:bg-blue-700">Book</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
